import React from "react";
import { CheckCircle2, Download } from "lucide-react";
import { COMPANY } from "@/data/site";

const ABOUT_IMG = "/about-generated.png";

const HIGHLIGHTS = [
  "Experienced craftsmanship and site engineering",
  "Premium certified materials sourced globally",
  "Timely delivery with zero-compromise finishing",
  "End-to-end warranty and after-sales support",
];

export const About = () => {
  return (
    <section id="about" data-testid="about-section" className="relative bg-white">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10 lg:px-14 py-24 md:py-32">
        <div className="grid lg:grid-cols-12 gap-14 lg:gap-20 items-start">
          {/* Left: image collage */}
          <div className="lg:col-span-6 relative">
            <div className="relative aspect-[4/5] w-full overflow-hidden bg-slate-100">
              <img
                src={ABOUT_IMG}
                alt="Interior with premium glass partitions"
                className="h-full w-full object-cover"
                loading="lazy"
              />
            </div>
            <div className="hidden md:block absolute -right-6 -bottom-10 w-56 bg-slate-900 text-white p-6">
              <div className="font-display text-4xl font-light leading-none">15+</div>
              <div className="mt-2 text-xs uppercase tracking-[0.2em] text-white/70">
                Years of combined experience
              </div>
            </div>
          </div>

          {/* Right: copy */}
          <div className="lg:col-span-6 lg:pl-8">
            <div className="overline text-blue-600 mb-6">About the company</div>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-light tracking-tighter text-slate-950 text-balance">
              A trusted name in glass and aluminum craftsmanship across the UAE.
            </h2>
            <p className="mt-8 text-slate-600 text-base md:text-lg leading-relaxed">
              Hasan Javed Glass & Aluminum LLC is a Dubai-based specialist in high-quality glass and
              aluminum fabrication, installation, repair and maintenance. From bespoke residential
              projects to large commercial fit-outs, our team blends experienced craftsmanship,
              precision engineering and premium materials to deliver work that stands the test of time.
            </p>
            <p className="mt-4 text-slate-600 text-base md:text-lg leading-relaxed">
              Every project is guided by three commitments: uncompromising quality, on-time delivery,
              and complete customer satisfaction.
            </p>

            <ul className="mt-10 space-y-4" data-testid="about-highlights">
              {HIGHLIGHTS.map((h, i) => (
                <li key={i} className="flex items-start gap-3 text-slate-800">
                  <CheckCircle2 className="h-5 w-5 text-blue-600 mt-0.5 flex-shrink-0" />
                  <span className="font-medium">{h}</span>
                </li>
              ))}
            </ul>

            <a
              href="/brochure/hasan-javed-brochure.pdf"
              target="_blank"
              rel="noreferrer"
              data-testid="download-brochure-btn"
              className="mt-10 inline-flex items-center gap-3 bg-slate-900 hover:bg-slate-800 text-white px-8 py-4 text-xs uppercase tracking-[0.22em] font-semibold transition-colors"
            >
              <Download className="h-4 w-4" />
              Download Company Brochure
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};
